import React, { Component } from 'react'
import styles from './References.css'

class References extends Component {
    render() {
        return (
            <div>
                <h2>Referenciák</h2>
                <ul className={styles.referencesList}>{this.props.references.map((reference, index) =>
                    <li key={index}>
                        <i className="fa fa-building-o"/> <a href={reference.link} target="_blank">{reference.name}</a>
                    </li>
                )}</ul>
            </div>
        )
    }
}

export default References


// WEBPACK FOOTER //
// ./src/components/references/References.js